
import React from 'react';
import { Check } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    "Haz preguntas ilimitadas sobre inmigración",
    "Accede a respuestas 24/7",
    "Descarga formularios en PDF", 
    "Compatible con celular o computadora",
    "Sin citas, sin esperas, sin confusión"
  ];

  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#FAF9F6]">
      <div className="max-w-4xl mx-auto">
        <h2 
          className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-8 sm:mb-12"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          Todo lo que incluye tu membresía
        </h2>
        
        <div className="space-y-4 sm:space-y-6 max-w-2xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm">
              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-green-500 flex items-center justify-center">
                <Check className="h-5 w-5 text-white" />
              </div>
              <p 
                className="text-base sm:text-lg text-gray-800 font-medium"
                style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
              >
                {feature}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
